import { Fragment, useEffect } from "react";

import i18next from 'i18next';

import classes from "./PrivacyPolicy.module.css";

function PrivacyPolicy(props) {
  // console.log('Footer.js-props', props);
  // const { t } = useTranslation("common");

  useEffect(() => {
    window.scrollTo(0, 0);
  },[]);

  return (
    <Fragment>
      <div className={classes.privacyPolicy}>
      <p>
        {i18next.t('privacyPolicy.text1', 
        'Privacy Policy'
        )}
      </p>
      <p>
        {i18next.t('privacyPolicy.text2',
          'This policy may be updated or revised without notice. It is the responsibility of the user to stay informed about privacy policy changes. Take note of other privacy issues that may affect you:'
        )}
      </p>
      <ul>
      
        <li>
          {i18next.t('privacyPolicy.text3', 
            'This website might be compromised.'
          )}
        </li>

        <li>
          {i18next.t('privacyPolicy.text4', 
            'Your computer might be compromised.'
          )}
        </li>
        <li>
          {i18next.t('privacyPolicy.text5', 
            'This website is hosted on Firebase, DigitalOcean and MongoDB infrastructures. They may and do have their own tracking systems on their servers. Those services have their own privacy policies and they are not covered by this privacy policy.'
          )}
        </li>
        <li>
          {i18next.t('privacyPolicy.text6', 
            'This website stores email, encrypted form of password, and other inputs of users at hosted Firebase, DigitalOcean and MongoDB infrastructures.'
          )}
        </li>
      </ul>
      </div>
    </Fragment>
  );
}

export default PrivacyPolicy;
